// Imports
import ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/noSourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".active[data-v-26d2ffac]{border-radius:.25rem .25rem 0 0;height:3.5rem;padding-top:.75rem}.tab[data-v-26d2ffac]:not(.active),.tab:not(.active) .tab_content[data-v-26d2ffac]:hover{background-color:rgba(0,0,0,.2)}", ""]);
// Exports
export default ___CSS_LOADER_EXPORT___;
